import { render } from "./Finish.vue?vue&type=template&id=474c79e0&bindings={\"c_finish\":\"setup\",\"wrongCodes\":\"setup\"}"
import script from "./Finish.vue?vue&type=script&lang=js"
export * from "./Finish.vue?vue&type=script&lang=js"

import "./Finish.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script